// Education Levels
export const EDUCATION_LEVELS = [
  'Primary School',
  'Secondary School',
  'Certificate',
  'Diploma',
  'Bachelor\'s Degree',
  'Master\'s Degree',
  'PhD',
  'Other'
];

// Industries
export const INDUSTRIES = [
  'Agriculture',
  'Technology',
  'Healthcare',
  'Education',
  'Manufacturing',
  'Retail',
  'Finance',
  'Construction',
  'Transportation',
  'Hospitality',
  'Media',
  'Entertainment',
  'Real Estate',
  'Energy',
  'Environmental Services',
  'Professional Services',
  'Non-Profit',
  'Other'
];

// Employment Positions/Roles
export const EMPLOYMENT_POSITIONS = [
  'Entry Level',
  'Junior',
  'Mid Level',
  'Senior',
  'Team Lead',
  'Manager',
  'Director',
  'Executive',
  'Other'
];

// School Types
export const SCHOOL_TYPES = [
  'Primary School',
  'Secondary School',
  'Technical Institute',
  'College',
  'University',
  'Vocational Training Center',
  'Other'
];

// Business Types
export const BUSINESS_TYPES = [
  'Sole Proprietorship',
  'Partnership',
  'Limited Company',
  'Cooperative',
  'Social Enterprise',
  'Startup',
  'Family Business',
  'Other'
];

// Study Years
export const STUDY_YEARS = [
  'First Year',
  'Second Year',
  'Third Year',
  'Fourth Year',
  'Fifth Year',
  'Final Year',
  'Other'
];
